import React from "react";
import { Animated } from "react-animated-css";
import { Link } from "react-scroll";
import { useTranslation } from 'react-i18next';


export default function Header() {


    const { t } = useTranslation();

    return (
      
            <div className="header__layers">
                <svg className="header__layers--first d-none d-xl-block" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" viewBox="0 0 1368.667 698.667">
                    <defs>
                        <linearGradient id="linear-gradient" x1="1.047" y1="1.062" x2="0.013" gradientUnits="objectBoundingBox">
                            <stop offset={0} stopColor="#fee6ff" />
                            <stop offset={1} stopColor="#f5ecff" />
                        </linearGradient>
                    </defs>
                    <path id="Trazado_3" data-name="Trazado 3" d="M1366,488s-64.667,173.333-250,168S861.243,535.956,710.667,541.333,477.349,696,248,696-2.667,646.667-2.667,646.667V-2.667H1366Z" transform="translate(2.667 2.667)" fill="url(#linear-gradient)" />
                </svg>

                <div className="container header__banner">
                    <div className="header__background-img--mobile d-block d-xl-none"></div>
                    <Animated animationIn="fadeInDown" animationOut="fadeOut" animationInDuration={1000} animationOutDuration={1000} isVisible>
                        <div className="row flex-row-reverse justify-content-between">
                            <div className="col-12 col-xl-5 col-xxl-5">
                               <img
  className="header__avatar"
  src={`${process.env.PUBLIC_URL}/img/desktop/new_avatar.png`}
  alt=""
/>
                            </div>
                            <div className="col-12 col-xl-6">
                                <h1 className="header__title">  {t('greeting')} <br /> {t('profile')} <span ></span></h1>

                                {/* <p>He colaborado con equipos multidisciplinarios en aseguradoras, fábricas de software, marketing y comercio electrónico, aplicando las mejores prácticas para entregar soluciones innovadoras y funcionales que marcan la diferencia en cada proyecto.</p> */}

                                <p className="header__caption">{t('aboutMe')}</p>

                                <Link className="header__link" type="button" activeClass="active"
                                    to="proyectos"
                                    offset={-60}
                                    spy
                                    smooth
                                    duration={300}>{t('myProjectsBtn')} </Link>
                            </div>

                        </div>
                    </Animated>
                </div>
               <img
  className="w-100 header__layers--second d-none d-xl-block"
  src={`${process.env.PUBLIC_URL}/img/desktop/dsk_bg.png`}
  alt="Background"
/>
            </div>
       
    )
};